class TokenService {
  private _token: string | null
  private _tokenData: any
  private _tokenRefresh
  private _isTokenRefreshPending: Boolean

  constructor() {
    this._token = localStorage.getItem('access_token') || null
    this._tokenData = this._token ? parseJwt(this._token) : null
    this._tokenRefresh = localStorage.getItem('refresh_token') || null
    this._isTokenRefreshPending = false
  }

  setToken(token: string) {
    if (!token) {
      throw new Error('Unexpected token value!')
    }

    this._token = token
    this._tokenData = parseJwt(token)
    localStorage.setItem('access_token', token)
  }

  setTokenRefresh(token: string) {
    if (!token) {
      throw new Error('Unexpected refresh token value!')
    }

    this._tokenRefresh = token
    localStorage.setItem('refresh_token', token)
  }

  clearTokens() {
    this._token = null
    this._tokenData = null
    this._tokenRefresh = null
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    this._isTokenRefreshPending = false
  }

  setPending(status: Boolean) {
    this._isTokenRefreshPending = Boolean(status)
  }

  get token() {
    return this._token
  }

  get tokenRefresh() {
    return this._tokenRefresh
  }

  get tokenData() {
    return this._tokenData
  }

  get expireDate() {
    return this._tokenData && parseInt(this._tokenData?.exp, 10)
  }

  get userType() {
    return this._tokenData && parseInt(this._tokenData?.type_id, 10)
  }

  get isPending() {
    return this._isTokenRefreshPending
  }
}

function parseJwt(token: string) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(window.atob(base64))
}

const tokenService = new TokenService()
export default tokenService